import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles((theme) => ({
    pageTitle: theme.globals.appPageTitle, 
}))

const DEFAULT_ITEMS_RULES = [
    { xs: "auto" },
    { xs: "auto" },
    { xs: true, md: true }
]

const PageTitle = ({ title,toolbar = null, navigation = null, itemsRules = DEFAULT_ITEMS_RULES }) => {

    const classes = useStyles()

    if (!title && !navigation && !toolbar) {
        return null
    }

    return (
        <Grid container alignItems="center" spacing={2} >
            {navigation && (
                <Grid item {...itemsRules[0]}>
                    {navigation}
                </Grid>
            )}
            {title && (
                <Grid item {...itemsRules[1]}>
                    <Typography variant="h5" component="h3" className={classes.pageTitle} gutterBottom>
                        {title}
                    </Typography>
                </Grid>
            )}
            {toolbar && title && (
                <Grid item {...itemsRules[2]}>
                    {toolbar}
                </Grid>
            )}
        </Grid>
    )
}

export default PageTitle